import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postInitiativesSyncJira } from '@api';
import { initiativesJiraIssueUpdateSlice } from '../../@sync/update';
import { InitiativeSyncJiraIssueName } from '../name';

export const postInitiativesSyncJiraSlice = createPostAsyncSlice({
	httpSagaOptions: {
		errorCodeActionCreators: [
			() => initiativesJiraIssueUpdateSlice.syncActionCreator({
				issueKey: ''
			})
		],
		preRequestActionCreators: [
			(request) => initiativesJiraIssueUpdateSlice.syncActionCreator({
				issueKey: request.issueKey
			})
		]
	},
	name: InitiativeSyncJiraIssueName,
	receive: false,
	request: true,
	requestHandler: postInitiativesSyncJira
});
